import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLightbulb,
  faBullseye,
  faHandshake,
  faUsers,
  faPaintBrush,
  faHeart,
} from '@fortawesome/free-solid-svg-icons';
import './style.css';

const values = [
  {
    title: 'Constant Innovation',
    icon: faLightbulb,
    description:
      'We’re always evolving. Testing and applying new solutions to stay ahead of what’s next.',
  },
  {
    title: 'Result-Driven',
    icon: faBullseye,
    description:
      'We don’t just check boxes — we measure impact. Your growth is our success.',
  },
  {
    title: 'Transparent Process',
    icon: faHandshake,
    description:
      'Clear communication, visible processes, and joint decision-making with clients.',
  },
  {
    title: 'Client-Centered',
    icon: faUsers,
    description:
      'We listen, guide, and stay involved. You’ll never get automated support from us (even though we use AI).',
  },
  {
    title: 'Functional Design',
    icon: faPaintBrush,
    description:
      'Our digital experiences don’t just look good — they work hard for your business.',
  },
  {
    title: 'Human Purpose',
    icon: faHeart,
    description:
      'Technology only matters if it empowers people. That’s our core belief.',
  },
];

function ValuesSection() {
  return (
    <section id="mission-vision" className="values-section">
      <Container>
        <div className="values-mission-vision rounded-4 mb-6">
          <Row className="align-items-start">
            <Col md={6} xs={12} className="mb-4 mb-md-0">
              <h5 className="fw-bold mb-3">🎯 Our Mission</h5>
              <p className="values-mission-text">
                We help businesses of all sizes transform their digital presence through strategic solutions,
                cutting-edge technology, and accessible AI. Our human-centered, creative approach puts your real
                goals at the heart of everything we do.
              </p>
            </Col>
            <Col md={6} xs={12}>
              <h5 className="fw-bold mb-3">👁 Our Vision</h5>
              <p className="values-mission-text">
                To be a Latin American benchmark in combining innovation, functional design, and personalized
                strategy — driving real transformation for brands from the inside out.
              </p>
            </Col>
          </Row>
        </div>

        {/* VALUES */}
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3 values-title">
            Our <span className="values-title-highlight">Values</span>
          </h2>
          <div className="values-lead">
            The principles that guide every project, every conversation, every success.
          </div>
        </div>

        <Row className="justify-content-center">
          {values.map((value, idx) => (
            <Col key={idx} xs={12} sm={6} md={4} className="d-flex justify-content-center mb-4">
              <div className="values-card">
                <div className="icon-circle">
                  <FontAwesomeIcon icon={value.icon} />
                </div>
                <h6 className="fw-bold mb-2">{value.title}</h6>
                <p className="values-description">{value.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default ValuesSection;
